import axios from 'axios';

export default {
  getLocalisations({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/localisation/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('insertLocalisations', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addLocalisation({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('addLocalisationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/localisation/add`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('addLocalisationRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('addLocalisationRequestError', err);
          reject(err);
        });
    });
  },
  editLocalisation({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('editLocalisationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/localisation/edit`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('editLocalisationRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('editLocalisationRequestError', err);
          reject(err);
        });
    });
  },
  removeLocalisation({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('removeLocalisationRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/localisation/destroy`,
        data: ctx,
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('removeLocalisationRequestSuccess', ctx);
          resolve(resp);
        })
        .catch(err => {
          commit('removeLocalisationRequestError', err);
          reject(err);
        });
    });
  },
  changeIsActive({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('changeIsActiveRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/localisation/changeIsActive`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('changeIsActiveRequestSuccess', ctx);
          resolve(resp);
        })
        .catch(err => {
          commit('changeIsActiveRequestError', err);
          reject(err);
        });
    });
  }
};
